import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxHeight: 600,
    overflow: 'auto',
    minWidth: 200,
  },
  clientWrapper: {
    margin: '10px 0',
    cursor: 'pointer',
    borderRadius: 4,
    padding: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));

export default useStyles;
